import './MyGoals.scss'

import { useHistory } from 'react-router-dom'
import { Alert, Card, Col, Row } from 'react-bootstrap'

import { navigateTo } from 'components/common/navigation'
import { ROUTE_CHECK_IN, ROUTE_CHECK_IN_SUMMARY } from 'components/common/helpers/Paths'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import UserCheckinContext from 'components/common/contexts/UserCheckinContext'
import CheckinChart from './CheckinChart'


export default function MyGoalsWidget() {
  const history = useHistory()

  const { summaryUserCheckin, todayUserCheckin } = useContext(UserCheckinContext)
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (!summaryUserCheckin) return []

    const dateList = summaryUserCheckin.map(s => s.checkin_date)
    const setDateList = [...new Set(dateList)]

    let data = setDateList.map((date) => {
      const measures = summaryUserCheckin.map(s => {
        if(s.checkin_date === date) return s.value
        return undefined
      }).filter(a => a)
      const data = {}
      data.name = date
      data.value = measures.reduce((p, c) => p + c)

      return data
    })

    data = data.map(d => {
      const dateStr = new Date(d.name.replace(/-/g, '/')).toLocaleDateString('en', {
        day: 'numeric',
        month: 'numeric'
      }).replace('/', '-')

      return {
        ...d,
        name: dateStr,
      }
    })

    setChartData(data)
  }, [summaryUserCheckin])

  const hasCheckin = useMemo(() => {
    if (!todayUserCheckin || todayUserCheckin.length === 0) return false
    return !todayUserCheckin?.some(t => t.value === 0)
  }, [todayUserCheckin])

  return (
    <div className='my-goals-widget mb-4'>
      <Row className='my-goals-widget__title'>
        <Col>
          <h3>Wellness Tracker</h3>
        </Col>
      </Row>
      <Row className='my-goals-widget__action mt-4'>
        <Col xs={{ span: 10, offset: 1 }} className='text-center'>
          <Card
            bg='light'
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()

              if (hasCheckin) {
                navigateTo(ROUTE_CHECK_IN_SUMMARY, history)
                return
              }
              navigateTo(ROUTE_CHECK_IN, history)
            }}
          >
            <Card.Body>
              {hasCheckin
                ? (
                  <>
                    <p className='mb-0'>How are you feeling today</p>
                    <p className='mb-0'>See your summary</p>
                  </>
                )
                : (
                  <>
                    <p className='mb-0'>How are you feeling today</p>
                    <p className='mb-0'>Complete your check-in</p>
                  </>
                )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {chartData.length > 1 && (
        <Row className='mt-4'>
          <Col style={{ height: '200px'}}>
            <CheckinChart
              chartData={chartData}
              dataKey='value'
              configIndex={1}
            />
          </Col>
        </Row>
      )}
      {chartData.length === 1 && hasCheckin && (
        <Alert variant='secondary'>
          Come back tomorrow to see your progress.
        </Alert>
      )}
    </div>
  )
}
